/**
 * import react
 */
import React, { useState } from 'react';

/**
 * import mateiral-ui
 */
import Button from '@material-ui/core/Button';

/**
 * import components
 */
import SlotAllocation from './slot-allocation';
import MessageDialog from './msg-dialog';

/**
 * import UI helper
 */
import { constVal } from '../slot-const';
import { confDetailsJsonToObj, mapSlotAndCameraUILogic } from './helper';

const SlotAssociation = (props) => {
  const [dlg, setDlg] = useState(false);
  const [hasBeenDialogProgress, setHasBeenDialogProgress] = useState(false);

  const handleDlgState = () => setDlg(prev => !prev);
  const handleSetHasBeenDialogProgress = (value) => setHasBeenDialogProgress(value);
  const localConfInfo = props.basicInstall || {};
  const config_details = localConfInfo.config_details || '{}';
  const confDetailsObj = confDetailsJsonToObj(config_details);

  const verificationProgress = () => {
    const childProps = {
      type: constVal.MSG_TYPE_INFORMATION,
      handleCancelOnClick: () => {
        handleSetHasBeenDialogProgress(true);
        handleDlgState();
      },
      content: 'Device has checking the camera authentication with the credential provided. Information will update ASAP'
    };
    return (
      <>
        <Button onClick={handleDlgState}>Slot Association</Button>
        {dlg ? <MessageDialog {...childProps} /> : null}
      </>
    );
  };

  const content = () => {
    const { basic_installation={}, slot_configuration={} } = confDetailsObj;
    const { install_progress_step=0} = basic_installation;
    if (install_progress_step === constVal.BASIC_INSTALL_START || install_progress_step === constVal.BASIC_INSTALL_VEIRY_COMPLETE || hasBeenDialogProgress) {
      const {camera_discovered={}} = basic_installation;
      const mapCameraSlotDetails = mapSlotAndCameraUILogic({ list: camera_discovered.camerasTable }, slot_configuration);
      if (mapCameraSlotDetails) {
        const childProps = {localConfInfo, mapCameraSlotDetails, handleDlgState, handleSetHasBeenDialogProgress, confDetailsObj, updateBasicInstall: props.updateBasicInstall};
        return (
          <>
            <Button onClick={handleDlgState}>Slot Association</Button>
            {dlg ? <SlotAllocation {...childProps} /> : null}
          </>
        );
      }
    } else if(install_progress_step === constVal.BASIC_INSTALL_VERIFY && !hasBeenDialogProgress) {
      return (
        <>
          {verificationProgress()}
        </>
      );
    }
    return null;
  };

  return (
    <>
      {content()}
    </>
  )
};

export default SlotAssociation;
